<template>
  <section
    v-if="content"
    class="contents"
    :class="{
      'contents--active': active
    }"
    @click="toggleActive()">
    <div
      class="contents__top"
      :class="{
        'contents__top--show': show,
        'contents__top--active': active
      }">
      <div class="contents__title">
        <router-link to="/">
          <h3 v-html="content.title"></h3>
        </router-link>
      </div>
      <div
        class="contents__top-menu"
        @click.self="active = !active">
        <button @click.self="active = !active">
          <span>Menu</span>
        </button>
      </div>
    </div>
    <div
      class="contents__bottom"
      :class="{
        'contents__bottom--show': show,
        'contents__bottom--active': active
      }">
      <nav class="contents__bottom-nav nav">
        <ul
          v-if="navPages"
          class="nav__list"
          :class="{
            // 'nav__list--thirds': content.pages.length > 6
          }">
          <li
            v-for="(page, key) in navPages"
            :key="`page${key}`"
            class="nav__list-item">
            <router-link :to="`${page.link}`">
              <h2 v-html="page.name"></h2>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Contents',
  props: {
    content: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      active: false,
      show: false,
      navPages: null
    }
  },
  watch: {
    '$route.path': function(newPath, oldPath) {
      if (newPath !== oldPath) {
        setTimeout(() => {
          this.active = false
        }, 200)
      }
    }
  },
  created() {
    const navPages = this.content.pages

    // navPages.unshift(this.content.home)

    this.navPages = navPages
  },
  methods: {
    toggleActive() {
      this.$emit('toggleActive', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.contents {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: $background;

  &__top {
    min-height:104px;
    padding: #{$page-padding * 1} $page-padding #{$page-padding * 1} $page-padding;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $background;
    z-index: 100;
    position: relative;
    // max-width: $content-width;
    margin: 0  auto;
    border-bottom: 3px solid $black;
    text-transform: uppercase;

    &--active {
      .contents__top-menu {
        &:before {
          content: 'Close';
        }

        button {
          &:before {
            top:50%;
            width:60%;
            left:50%;
            transform:translateY(-50%) translateX(-50%) rotate(-45deg);
          }
          span {
            opacity:0;
          }
          &:after {
            top:50%;
            width:60%;
            left:50%;
            transform:translateY(-50%) translateX(-50%) rotate(45deg);
          }
        }
      }
    }

    &-menu {
      display: flex;
      align-items: center;

      &:before {
        content: 'Menu';
        font-size: $heading;
        line-height: 0.75;
        padding: 0 $page-padding 0 0;
      }

      button {
        @include button_resets;
        cursor: pointer;
        width:110px;
        height:36px;
        position:relative;

        &:before {
          content:'';
          position:absolute;
          top:0%;
          left:0%;
          display:inline-block;
          width:100%;
          height:7px;
          background-color:#000;
        }
        span {
          display:inline-block;
          position:absolute;
          top:50%;
          left:0%;
          transform:translateY(-50%);
          width:100%;
          height:7px;
          background-color:#000;
          font-size: 0px;
          pointer-events: none;
        }

        &:after {
          content:'';
          display:inline-block;
          position:absolute;
          top:calc(100% - 7px);
          left:0%;
          width:100%;
          height:7px;
          background-color:#000;
        }
      }
    }

    &--active {
    //   .contents__top-menu {
    //     &:before {
    //       content: 'Close';
    //     }
    //     button {
    //       &:before {
    //         top: 50%;
    //         width: 80%;
    //         transform: translate(-50%, -50%) rotate(-45deg);
    //       }
    //       span {
    //         opacity: 0;
    //       }

    //       &:after {
    //         top: 50%;
    //         width: 80%;
    //         transform: translate(-50%, -50%) rotate(45deg);
    //       }

    //     }
    //   }
    }
  }

  &__bottom {
    padding: $page-padding;
    margin: 0  auto;
    margin-top: -400px;
    transition: margin-top 400ms ease-in-out;
    // max-width: $content-width;
    border-bottom: 3px solid $black;

    &--active {
      margin-top: 0;
    }

    &-nav {
      width: 100%;
      .nav__list {
        width: 100%;
        column-width: 50%;
        column-count: 2;

        &--thirds {
          width: 75%;
          column-width: 25%;
          column-count: 3;
        }

        &-item {
          width: 100%;

          h1 {
            text-transform: uppercase;
          }

          a {
            transition: color 200ms ease-in-out;
            &:hover {
              color: $dk-grey;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: $mobile) {
    &__top {
      padding: #{$padding} $mobile-padding;
      transition: margin-top 800ms ease-in-out;
      border-bottom: 2px solid $color;
      min-height: unset; // 72px;

      &-menu {
        &:before {
          display: none;
        }

        button {
          width: 60px;
          height: 24px;

          &:before {
            height: 4px;
          }

          span {
            height: 4px;
          }

          &:after {
            height: 4px;
            top: calc(100% - 4px);
          }
        }
      }
    }

    &__bottom {
      padding: #{$padding / 2} $mobile-padding;
      border-bottom: 2px solid $color;

      &-nav {
        .nav__list {
          width: 100%;
          column-count: 1;
          column-width: 100%;
          &-item {
            width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
